import MainWrapper from "@/components/base/MainWrapper";
import RegionPage from "@/components/region/RegionPage";
import CountryPage from "@/components/country/CountryPage";
import CityPage from "@/components/city/CityPage";
import TourPage from "@/components/tour/TourPage";
import {fetchStaticPaths, fetchStaticProps} from "@/services/dataFetcher";
import WrongPageSection from "@/components/other/WrongPageSection";
import TourPageVariantB from "@/components/tour/TourPageVariantB";
import StaticPage from "@/components/static/StaticPage";
import CityTourGroupPage from "@/components/city/CityTourGroupPage";

export const renderPage = (type, data, variant, isMobile = false) => {
    switch (type) {
        case 'region':
            return <RegionPage data={data} />;
        case 'country':
            return <CountryPage data={data} />;
        case 'city':
            return <CityPage data={data} />;
        case 'city_tour_group':
            return <CityTourGroupPage data={data} />;
        case 'tour':
            return <TourPageVariantB data={data} isMobileDefault={isMobile} />;
        case 'world_tour_country':
            return <CountryPage data={data} />;
        case 'world_tour_city':
            return <CityPage data={data} />;
        case 'world_tour':
            return <TourPage data={data} />;
        case 'static':
            return <StaticPage data={data} />;
        default:
            return <WrongPageSection/>;
    }
};

const PageFromSlug = ({ data, isMobile }) => {
    if (!data) {
        return <div>Page not found</div>; // Fallback for unexpected cases
    }

    // Destructure data for easier access
    const {
        ab,
        regions,
        header,
        footer,
        socialLinks,
        searchOptions,
        isWorldTour = false,
        page,
    } = data?.data || {};


    const { type, data: pageData } = page || {};
    const dropdownData = pageData?.showDropdown ? pageData?.dropdowns : [];

    return (
        <MainWrapper
            regionsData={regions}
            headerData={header}
            footerData={footer}
            socialLinks={socialLinks}
            searchOptions={searchOptions}
            isWorldTour={isWorldTour}
            dropdownData={dropdownData}
            isMobileDefault={isMobile}
            whatsappData={page?.data?.whatsapp}
        >
            {/*{*/}
            {/*    ab?.variant === 'b' ?*/}
            {/*        null*/}
            {/*        :*/}
            {/*        renderPage(type, data)*/}
            {/*}*/}
            {renderPage(type, data, data?.variant, isMobile)}
        </MainWrapper>
    );
};


// export const getStaticPaths = async () => {
//     return await fetchStaticPaths("getAllSlugs", ({ slug }) => ({
//         params: { slug },
//     }));
// };

export const getServerSideProps = async (context) => {
    const { slug } = context.params;

    if(slug.includes('monitoring')){
        return {
            props: {},
        };
    }

    return await fetchStaticProps("getDataBySlug", { slug },context);
};

export default PageFromSlug;
